export default "__VITE_ASSET__2f637322__"